export const getNormalizedScore = (score: number, totalScore: number) => {
	return (score / totalScore) * 100;
};
